/* eslint-disable import/order */
import AppBar from '@material-ui/core/AppBar'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'
import withStyles from '@material-ui/core/styles/withStyles'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import styles from '../../../resources/theme/users'
import { clearBilling, edit, fetchBilling, update } from '../BillingActions'
import Form from './Form'
import { Link } from 'react-router-dom'
import { Grid, Slide } from '@material-ui/core'
import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import colors from '../../../assets/colors'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'

function Transition(props) {
  return <Slide direction="down" {...props} />
}

function EditBill(props) {
  const billing = useSelector(state => state.billing.editingBilling)

  const dispatch = useDispatch()

  const history = useHistory()

  const location = useLocation()

  const onSubmit = values => {
    dispatch(update(values)).then(data => {
      if (data?.status === 200) {
        onClose()
      }
    })
  }

  const onClose = () => {
    if (location.key) {
      // veio de navegação interna → goBack restaura a listagem com os filtros
      history.goBack()
    } else {
      // acesso direto (URL colada, F5, nova aba) → não há histórico pra voltar
      history.push('/billing')
    }
  }

  useEffect(() => {
    dispatch(clearBilling())
    dispatch(edit(props.match.params.id))
  }, [])

  return (
    <BaseFilterModal title="Editar conta" open handleOpen={onClose}>
      <Grid container xs={12} item direction="row" style={{ width: '540px' }}>
        <Grid item xs={12}>
          <Typography
            style={{ fontSize: '16px', fontWeight: 'normal' }}
            color={colors.primary}
          >
            Utilize os campos abaixo para editar uma conta
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Form data={billing} onClose={onClose} onSubmit={onSubmit} />
        </Grid>
      </Grid>
    </BaseFilterModal>
  )
}

export default withStyles(styles)(EditBill)
